// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.totalquestionsview .react-bootstrap-table .table td {
  text-align: left !important;
}

.Own_Question_Types {
  position: relative;
}
.Own_Question_Types .rdtPicker {
  bottom: 45px;
}
.Own_Question_Types .list-unstyled li {
  position: relative;
  margin-bottom: 30px;
}
.Own_Question_Types .list-unstyled li:last-child {
  margin-bottom: 0;
}
.Own_Question_Types .list-unstyled li .form-group > .card:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.Own_Question_Types .list-unstyled li .form-group > .card:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.Own_Question_Types .list-unstyled li .form-group > .card + .card {
  margin-left: 0;
  border-left: 0;
}
.Own_Question_Types .custom_setup {
  position: relative;
}
.Own_Question_Types .custom_setup .chapter-list li,
.Own_Question_Types .custom_setup .subject-list li,
.Own_Question_Types .custom_setup .chap-topic-list li {
  margin-bottom: 0;
  padding: 0.2rem 0.5rem;
}
.Own_Question_Types .custom_setup .chapter-list li .counts,
.Own_Question_Types .custom_setup .chapter-list li .arrow,
.Own_Question_Types .custom_setup .subject-list li .counts,
.Own_Question_Types .custom_setup .subject-list li .arrow {
  visibility: hidden;
}
.Own_Question_Types .custom_setup .subject-list li:hover,
.Own_Question_Types .custom_setup .subject-list li.active,
.Own_Question_Types .custom_setup .chapter-list li:hover,
.Own_Question_Types .custom_setup .chapter-list li.active,
.Own_Question_Types .custom_setup .chap-topic-list li:hover,
.Own_Question_Types .custom_setup .chap-topic-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #efefef;
  padding: 0.2rem 0.5rem;
}
.Own_Question_Types .custom_setup .subject-list li:hover .counts,
.Own_Question_Types .custom_setup .subject-list li:hover .arrow,
.Own_Question_Types .custom_setup .subject-list li.active .counts,
.Own_Question_Types .custom_setup .subject-list li.active .arrow,
.Own_Question_Types .custom_setup .chapter-list li:hover .counts,
.Own_Question_Types .custom_setup .chapter-list li:hover .arrow,
.Own_Question_Types .custom_setup .chapter-list li.active .counts,
.Own_Question_Types .custom_setup .chapter-list li.active .arrow {
  visibility: visible;
}
@media (min-width: 992px) {
  .Own_Question_Types .custom_setup .card-body .no-gutters > [class*=col-]:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .Own_Question_Types .custom_setup .card-body .no-gutters > [class*=col-]:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .Own_Question_Types .custom_setup .card-body .no-gutters > [class*=col-] + [class*=col-] {
    margin-left: 0;
    border-left: 0;
  }
}
@media (min-width: 992px) {
  .Own_Question_Types .aside {
    position: fixed;
    top: 70px;
    right: 0;
    width: 260px;
    z-index: 2;
  }
}
.Own_Question_Types .aside .table-borderless th {
  padding: 0.3rem 0.5rem;
  border: 0;
}
.Own_Question_Types .aside .single-list-card .topic-list li {
  margin-bottom: 0;
  padding: 0.2rem 0.5rem;
  text-transform: capitalize;
}
.Own_Question_Types .aside .single-list-card .topic-list li:hover,
.Own_Question_Types .aside .single-list-card .topic-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #efefef;
  padding: 0.2rem 0.5rem;
}
.Own_Question_Types .aside .list-unstyled.chapter-list li {
  margin-bottom: 0;
  padding: 0.2rem 0.5rem;
  text-transform: capitalize;
}
.Own_Question_Types .aside .list-unstyled.chapter-list li a {
  color: #222222;
}

@media (min-width: 1200px) {
  .matrixlistoptions li {
    min-height: 44px;
  }
}

.go4079732705.multi-select .select-panel .go977458394.select-item {
  margin-bottom: 0 !important;
}
.go4079732705.multi-select .select-panel .go977458394.select-item .go14798910 span {
  display: inline-block;
  padding-left: 18px;
}
.go4079732705.multi-select .select-panel li {
  line-height: 15px !important;
  margin-bottom: 0 !important;
}
.go4079732705.multi-select .select-panel li .go977458394.select-item {
  margin-bottom: 0 !important;
}
.go4079732705.multi-select .select-panel li .go977458394.select-item .go14798910 span {
  display: flex;
  padding-left: 30px;
  margin-top: -1rem;
  align-items: start;
}`, "",{"version":3,"sources":["webpack://./src/neetjee_guru/components/questioners/create_question_paper/own_question_paper/own_question_types/_ownquestiontype.scss"],"names":[],"mappings":"AACE;EACE,2BAAA;AAAJ;;AAGA;EACE,kBAAA;AAAF;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,kBAAA;EACA,mBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAII;EACE,0BAAA;EACA,6BAAA;AAFN;AAKI;EACE,yBAAA;EACA,4BAAA;AAHN;AAMI;EACE,cAAA;EACA,cAAA;AAJN;AAQE;EACE,kBAAA;AANJ;AAQI;;;EAGE,gBAAA;EACA,sBAAA;AANN;AAWM;;;;EAEE,kBAAA;AAPR;AAWI;;;;;;EAME,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AATN;AAgBM;;;;;;;;EAEE,mBAAA;AARR;AAaM;EACE;IACE,0BAAA;IACA,6BAAA;EAXR;EAcM;IACE,yBAAA;IACA,4BAAA;EAZR;EAeM;IACE,cAAA;IACA,cAAA;EAbR;AACF;AAmBI;EADF;IAEI,eAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;IACA,UAAA;EAhBJ;AACF;AAkBI;EACE,sBAAA;EACA,SAAA;AAhBN;AAoBM;EACE,gBAAA;EACA,sBAAA;EACA,0BAAA;AAlBR;AAqBM;;EAEE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAnBR;AAuBI;EACE,gBAAA;EACA,sBAAA;EACA,0BAAA;AArBN;AAuBM;EACE,cAAA;AArBR;;AA6BI;EADF;IAEI,gBAAA;EAzBJ;AACF;;AAmCI;EACE,2BAAA;AAhCN;AAiCM;EACE,qBAAA;EACA,kBAAA;AA/BR;AAkCI;EACE,4BAAA;EACA,2BAAA;AAhCN;AAiCM;EACE,2BAAA;AA/BR;AAiCQ;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA/BV","sourcesContent":[".totalquestionsview{\n  .react-bootstrap-table .table td {\n    text-align: left !important;\n  }\n}\n.Own_Question_Types {\n  position: relative;\n\n  .rdtPicker {\n    bottom: 45px;\n  }\n\n  .list-unstyled li {\n    position: relative;\n    margin-bottom: 30px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .form-group > .card:not(:last-child) {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n\n    .form-group > .card:not(:first-child) {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n\n    .form-group > .card + .card {\n      margin-left: 0;\n      border-left: 0;\n    }\n  }\n\n  .custom_setup {\n    position: relative;\n\n    .chapter-list li,\n    .subject-list li,\n    .chap-topic-list li {\n      margin-bottom: 0;\n      padding: 0.2rem 0.5rem;\n    }\n\n    .chapter-list li,\n    .subject-list li {\n      .counts,\n      .arrow {\n        visibility: hidden;\n      }\n    }\n\n    .subject-list li:hover,\n    .subject-list li.active,\n    .chapter-list li:hover,\n    .chapter-list li.active,\n    .chap-topic-list li:hover,\n    .chap-topic-list li.active {\n      cursor: pointer;\n      border-radius: 2px;\n      background: #efefef;\n      padding: 0.2rem 0.5rem;\n    }\n\n    .subject-list li:hover,\n    .subject-list li.active,\n    .chapter-list li:hover,\n    .chapter-list li.active {\n      .counts,\n      .arrow {\n        visibility: visible;\n      }\n    }\n\n    .card-body {\n      @media (min-width: 992px) {\n        .no-gutters > [class*=\"col-\"]:not(:last-child) {\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        }\n\n        .no-gutters > [class*=\"col-\"]:not(:first-child) {\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n\n        .no-gutters > [class*=\"col-\"] + [class*=\"col-\"] {\n          margin-left: 0;\n          border-left: 0;\n        }\n      }\n    }\n  }\n\n  .aside {\n    @media (min-width: 992px) {\n      position: fixed;\n      top: 70px;\n      right: 0;\n      width: 260px;\n      z-index: 2;\n    }\n\n    .table-borderless th {\n      padding: 0.3rem 0.5rem;\n      border: 0;\n    }\n\n    .single-list-card {\n      .topic-list li {\n        margin-bottom: 0;\n        padding: 0.2rem 0.5rem;\n        text-transform: capitalize;\n      }\n\n      .topic-list li:hover,\n      .topic-list li.active {\n        cursor: pointer;\n        border-radius: 2px;\n        background: #efefef;\n        padding: 0.2rem 0.5rem;\n      }\n    }\n\n    .list-unstyled.chapter-list li {\n      margin-bottom: 0;\n      padding: 0.2rem 0.5rem;\n      text-transform: capitalize;\n\n      a {\n        color: #222222;\n      }\n    }\n  }\n}\n// customdevcss\n.matrixlistoptions {\n  li {\n    @media (min-width: 1200px) {\n      min-height: 44px;\n    }\n    // p {\n    //   overflow: hidden;\n    //   text-overflow: ellipsis;\n    //   white-space: nowrap;\n    // }\n  }\n}\n.go4079732705.multi-select {\n  .select-panel {\n    .go977458394.select-item {\n      margin-bottom: 0 !important;\n      .go14798910 span {\n        display: inline-block;\n        padding-left: 18px;\n      }\n    }\n    li {\n      line-height: 15px !important;\n      margin-bottom: 0 !important;\n      .go977458394.select-item {\n        margin-bottom: 0 !important;\n\n        .go14798910 span {\n          display: flex;\n          padding-left: 30px;\n          margin-top: -1rem;\n          align-items: start;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
